module.exports = __webpack_public_path__ + "img/phone.47e15e4f.svg";